import React from 'react';
import './ProfileBanner.css';
import PlayButton from '../components/PlayButton';
import MoreInfoButton from '../components/MoreInfoButton';
import { portfolioData } from '../data/portfolioData';
import { useNavigate } from 'react-router-dom';

const ProfileBanner: React.FC = () => {
  const { profileBanner } = portfolioData;
  const navigate = useNavigate();

  const handlePlayClick = () => {
    navigate('/resume');
  };

  const handleLinkedinClick = () => { 
    navigate('/contact-me');
  }

  return (
    <div className="profile-banner">
      <div className="banner-content">
        <h1 className="banner-headline" id='headline'>{profileBanner.headline}</h1>
        
        <div className="banner-credentials">
          {profileBanner.credentials.map((credential, index) => (
            <span key={index} className="credential-badge">
              {credential}
            </span>
          ))}
        </div>

        <p className="banner-description">
          {profileBanner.profileSummary}
        </p>

        <div className="expertise-section">
          {profileBanner.expertise.map((item, index) => (
            <div key={index} className="expertise-item">
              <span className="expertise-icon">▹</span>
              {item}
            </div>
          ))}
        </div>

        <div className="banner-buttons">
          <PlayButton onClick={handlePlayClick} label={portfolioData.profileBanner.callToAction} />
          <MoreInfoButton onClick={handleLinkedinClick} label="Connect" />
        </div>
      </div>
    </div>
  );
};

export default ProfileBanner;
